import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageSectionItem from "./common/ImageSectionItem"
import ImageTitleItem from "./common/ImageTitleItem"
import PaddingSection from "./common/PaddingSection"
import SeparatorLine from "./common/SeparatorLine"
import HalfTextItem from "./common/HalfTextItem"
import IconPanel from "./common/IconPanel"
import "./Videoact.css"
import { useEffect } from "react"

const Videoact = () => {

    useEffect(() => {
                document.title = 'Séneca - Video-acta'
        window.scrollTo(0, 0)
    }, [])

    return (
        <main className="videoact-main">

            <ImageTitleItem
                imageURL="/images/videoact/videoacta-1.jpg"
                imageURLMobile="/images/videoact/videoacta-1m.jpg"
                titleText="Vídeo-acta, el vídeo como diario literal de sesiones"
                icon="bi bi-diagram-3-fill blue-icon"
                subtitleText="Séneca gestiona la autenticidad e integridad de la vídeo-acta con la firma del Secretario mediante certificado digital o DNI-e, así como su validación pública."
            />
            <SliderImageSeparator />

            <PaddingSection />

            <HalfTextItem
                textItems={[
                    [
                        "¿Qué aplicaciones específicas tiene Séneca en las instituciones locales?",
                        [
                            "<p class='middle-section-label'><strong>Séneca se ha desarrollado para la gestión de contenidos audiovisuales para entornos institucionales.</strong> Creando un entorno seguro y estable, el software ofrece, específicamente para Ayuntamientos, distintas opciones configurables para:</p>",
                            "<p class='middle-section-label'><ul class='middle-section-label ml-50'><li>Videoacta</li><li>Control de presencia de concejales</li><li>Posicionamiento automático de cámaras</li><li>Grabación</li><li>Reproducción</li><li>Catalogación</li><li>Transcripción</li><li>Archivo digital</li><li>Publicación</li><li>Acceso a través de web</li></ul></p>"
                        ]
                    ],
                    [
                        "¿Qué ventajas aporta Séneca para un Secretario de Ayuntamiento?",
                        [
                            "<p class='middle-section-label'>Séneca permite que los Secretarios puedan certificar el vídeo y vincularlo al acta, generando una vídeo-acta.</p>",
                            "<p class='middle-section-label'>De esta forma, el vídeo se transforma en un diario literal de sesiones: Séneca gestiona la autenticidad e integridad de la vídeo-acta con la firma del Secretario mediante certificado digital o DNI-e, así como su validación pública. En un solo documento, se guardan en el repositorio para ser consultados y contrastados con total transparencia.</p>",
                            "<p class='middle-section-label'><strong>Séneca es la solución que hace más fácil la grabación y asegura la acreditación de su autenticidad e integridad por el Secretario.</strong></p>"
                        ]
                    ]
                ]}
            />
            <SeparatorLine />

            <ImageSectionItem
                imageURL="/images/videoact/videoacta-2.png"
                imagePosition="after"
                layout="column"
                title="¿Qué opciones ofrece Séneca para los Ayuntamientos?"
                textArray={[
                    "<p class='middle-section-label'>Séneca dispone de dos sistemas de gestión de contenidos audiovisuales para instituciones, FX y XS, que pueden funcionar independiemente o en conjunto.</p>",
                    "<p class='middle-section-label'>Séneca XS es un software para grabación de plenos y Séneca FX una mediateca online desde la que se puede acceder a cualquier sesión. Son dos productos independientes, que combinados forman el mejor sistema disponible en el mercado.</p>",
                    "<p class='middle-section-label'>Pregúntenos cuál de las opciones es la más adecuada para su caso.</p>",
                ]}
                isBigImage="true"
                imageClassName="process-image"
            />
            <SeparatorLine />

            <IconPanel
                title="Algunas instituciones en las que ya está instalado Séneca"
                iconArray={[
                    {
                        title: "Juntas Generales de Álava",
                        href: "https://mediateca.jjggalava.eus/activity",
                        src: "/images/videoact/institutions/jalava.png"
                    },
                    {
                        title: "Juntas Generales de Gipuzkoa",
                        href: "https://jggipuzkoa.seneca.tv/activity",
                        src: "/images/videoact/institutions/jgipuzkoa.png"
                    },
                    {
                        title: "Diputación de Cádiz",
                        href: "https://mediateca-dipucadiz.seneca.tv/activity",
                        src: "/images/videoact/institutions/dcadiz.png"
                    },
                    {
                        title: "Deputación da Coruña",
                        href: "https://plenos.dacoruna.gal/activity",
                        src: "/images/videoact/institutions/dcoruna.png"
                    },
                    {
                        title: "Diputación de Guadalajara",
                        href: "https://mediatecadguadalajara.seneca.tv/activity",
                        src: "/images/videoact/institutions/dguadalajara.png"
                    },
                    {
                        title: "Diputación de León",
                        href: "https://dipuleon.seneca.tv/activity",
                        src: "/images/videoact/institutions/dleon.png"
                    },
                    {
                        title: "Deputación de Pontevedra",
                        href: "https://depontevedra.seneca.tv/activity",
                        src: "/images/videoact/institutions/dpontevedra.png"
                    },
                    {
                        title: "Diputación de Valladolid",
                        href: "https://diputaciondevalladolid.seneca.tv/activity",
                        src: "/images/videoact/institutions/dvalladolid.png"
                    },
                    {
                        title: "Cabildo del Hierro",
                        href: "https://plenos.elhierro.es/activity",
                        src: "/images/videoact/institutions/celhierro.png"
                    },
                    {
                        title: "Cabildo de Tenerife",
                        href: "https://cabildotenerife.seneca.tv/activity",
                        src: "/images/videoact/institutions/ctenerife.png"
                    },
                    {
                        title: "Ajuntament d'Andratx",
                        href: "https://andratx.seneca.tv/activity",
                        src: "/images/videoact/institutions/aandratx.png"
                    },
                    {
                        title: "Ajuntament de Badia del Vallés",
                        href: "https://badiadelvalles.seneca.tv/activity",
                        src: "/images/videoact/institutions/abadia.png"
                    },
                    {
                        title: "Ayuntamiendo de Cáceres",
                        href: "https://caceres.seneca.tv/activity",
                        src: "/images/videoact/institutions/acaceres.png"
                    },
                    {
                        title: "Ayuntamiento de Camargo",
                        href: "https://acamargo.seneca.tv/activity",
                        src: "/images/videoact/institutions/acamargo.png"
                    },
                    {
                        title: "Ayuntamiento de Chiclana",
                        href: "https://chiclana.seneca.tv/activity",
                        src: "/images/videoact/institutions/achiclana.png"
                    },
                    {
                        title: "Ayuntamiento de Colmenar Viejo",
                        href: "https://colmenarviejo.seneca.tv/activity",
                        src: "/images/videoact/institutions/acolmenarviejo.png"
                    },
                    {
                        title: "Ayuntamiento de Eibar",
                        href: "https://eibar.seneca.tv/activity",
                        src: "/images/videoact/institutions/aeibar.png"
                    },
                    {
                        title: "Ayuntamiento de Getxo",
                        href: "https://getxo.seneca.tv/activity",
                        src: "/images/videoact/institutions/agetxo.png"
                    },
                    {
                        title: "Ayuntamiento de Móstoles",
                        href: "https://diariodesesionesplenos.mostoles.es/activity",
                        src: "/images/videoact/institutions/amostoles.png"
                    },
                    {
                        title: "Concello do Porriño",
                        href: "https://mediateca-oporrino.seneca.tv/activity",
                        src: "/images/videoact/institutions/aporrino.png"
                    },
                    {
                        title: "Ayuntamiento de Puerto Real",
                        href: "https://puertoreal.seneca.tv/activity",
                        src: "/images/videoact/institutions/apuertoreal.png"
                    },
                    {
                        title: "Concello de Sada",
                        href: "https://mediateca-sada.seneca.tv/activity",
                        src: "/images/videoact/institutions/asada.png"
                    },
                    {
                        title: "Ayuntamiento de San Roque",
                        href: "https://mediateca.sanroque.es/activity",
                        src: "/images/videoact/institutions/asanroque.png"
                    },
                    {
                        title: "Ajuntament de Sant Vicenç dels Horts",
                        href: "https://asvh.seneca.tv/activity",
                        src: "/images/videoact/institutions/asantvicens.png"
                    },
                    {
                        title: "Ayuntamiento de Valladolid",
                        href: "https://avalladolid.seneca.tv/activity",
                        src: "/images/videoact/institutions/avalladolid.png"
                    },
                    {
                        title: "https://aytovalverde.seneca.tv/activity",
                        href: "Ayuntamiento de Valverde",
                        src: "/images/videoact/institutions/avalverde.png"
                    }
                ]}
            />

        </main>
    )
}

export default Videoact